import { render } from "./TrocarNivel.vue?vue&type=template&id=311d0106&scoped=true"
import script from "./TrocarNivel.vue?vue&type=script&lang=js"
export * from "./TrocarNivel.vue?vue&type=script&lang=js"

import "./TrocarNivel.vue?vue&type=style&index=0&id=311d0106&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311d0106"]])

export default __exports__